import { render, staticRenderFns } from "./AccountRecoverRequest.vue?vue&type=template&id=0594ba75&"
import script from "./AccountRecoverRequest.vue?vue&type=script&lang=js&"
export * from "./AccountRecoverRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports